import { Component, EventEmitter, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationSelection, validLocation } from 'src/app/services/location-lookup.service';

@Component({
  selector: 'app-confirm-location',
  templateUrl: './confirm-location-modal.component.html',
  styleUrls: ['./confirm-location-modal.component.scss'],
})
export class ConfirmLocationModalComponent {
  @ViewChild('confirmLocationModal') confirmLocationTemplate!: TemplateRef<any>;
  @Output() confirmed = new EventEmitter<LocationSelection>();
  initialLocation: LocationSelection | null = null;
  selectedLocation: LocationSelection | null = null;
  private modalService = inject(NgbModal);

  open(location: LocationSelection | null): void {
    if (!validLocation(location)) return;
    this.initialLocation = { ...location };
    this.selectedLocation = null;
    this.modalService.open(this.confirmLocationTemplate, {
      windowClass: 'project-modal confirm-location-modal',
      centered: true,
      backdropClass: 'primary-backdrop',
    });
  }

  confirm(modal: any): void {
    if (!validLocation(this.selectedLocation) || !this.selectedLocation.address) return;
    const location = { ...this.selectedLocation };
    modal.close();
    this.confirmed.emit(location);
  }
}
